<template>
    <div>
        <!-- FASE 4 / BLOCO AE — CI 19, 20, 24, 27, 30, 39-46, 58-61 -->

        <div v-if="carregando" class="loading-form" style="min-height:130px">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-if="!carregando && d.tarefa">

            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="16" :md="16">
                    <h3 class="titulo">{{ d.tarefa.assunto }}</h3>
                    <div class="meta">
                        <span class="ident">{{ d.tarefa.identificador || 'rascunho' }}</span>
                        · {{ d.tipo ? d.tipo.nome : '' }}
                        · <el-tag size="mini" :type="corSituacao(d.tarefa.situacao)">{{ d.tarefa.situacao }}</el-tag>
                        <el-tag v-if="d.tarefa.privada" size="mini" type="danger">privada</el-tag>
                        <el-tag v-if="d.tarefa.bloqueada" size="mini" type="warning">trâmites bloqueados</el-tag>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                    <!-- CI 24 -->
                    <el-button v-if="!confirmeiLeitura" type="success" size="small" icon="el-icon-check"
                               @click="confirmarLeitura">CONFIRMAR LEITURA</el-button>
                    <el-tag v-else type="success" size="small">Leitura confirmada</el-tag>
                    <!-- CI 61 -->
                    <el-button type="default" size="small" icon="el-icon-printer"
                               @click="relatorio">RELATÓRIO</el-button>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="16" :md="16">
                    <div class="corpo" v-html="d.tarefa.conteudo"></div>

                    <div v-if="anexosDaTarefa.length" class="u-mt-10">
                        <strong class="rotulo">Anexos</strong>
                        <div v-for="a in anexosDaTarefa" :key="a.id" class="anexo">
                            <i class="el-icon-document"></i>
                            <a href="#" @click.prevent="baixar(a)">{{ a.nome_original }}</a>
                            <span class="meta">({{ a.tamanho | tamanho }})</span>
                        </div>
                    </div>
                </el-col>

                <el-col :xs="24" :sm="8" :md="8">
                    <div class="painel">
                        <strong class="rotulo">Prazo</strong>
                        <div>{{ d.tarefa.prazo_conclusao | formatarData }}</div>

                        <!-- CI 30 -->
                        <strong class="rotulo u-mt-10">Participantes</strong>
                        <div v-for="p in d.participantes" :key="p.id" class="participante">
                            <i :class="p.tipo === 'grupo' ? 'el-icon-s-custom' : 'el-icon-user'"></i>
                            {{ p.nome }}
                            <el-tag v-if="p.origem === 'incluido'" size="mini">incluído depois</el-tag>
                        </div>

                        <!-- CI 48 — só o remetente inclui -->
                        <el-button v-if="d.permissoes.pode_incluir_participante" type="text"
                                   icon="el-icon-plus" @click="dialogParticipante = true">
                            incluir participante
                        </el-button>

                        <!-- CI 20, 27 -->
                        <strong class="rotulo u-mt-10">Leituras</strong>
                        <div v-for="l in d.leituras" :key="l.id" class="leitura">
                            {{ l.name }}
                            <i v-if="l.confirmado_em" class="el-icon-circle-check confirmou"
                               title="confirmou leitura"></i>
                            <i v-else-if="l.visualizado_em" class="el-icon-view" title="visualizou"></i>
                            <i v-else class="el-icon-time" title="não abriu"></i>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-divider content-position="left">
                Movimentações ({{ d.tramites.length }})
            </el-divider>

            <!-- CI 39 — cronológico -->
            <div v-for="t in d.tramites" :key="t.id" class="tramite">
                <div class="tramite-cab">
                    <el-tag size="mini" :type="corTramite(t.tipo)">{{ t.tipo }}</el-tag>
                    <strong>{{ t.autor }}</strong>
                    <!-- CI 46 — os dois nomes -->
                    <span v-if="t.representado" class="meta">em nome de {{ t.representado }}</span>
                    <span class="meta">· {{ t.created_at | formatarData }}</span>
                    <span v-if="t.editado_em" class="meta">
                        · editado
                        <a href="#" @click.prevent="verHistorico(t)">ver histórico</a>
                    </span>
                    <span class="acoes-tramite">
                        <el-button v-if="podeEditarTramite(t)" type="text" size="mini"
                                   @click="abrirEdicao(t)">editar</el-button>
                        <el-button class="u-ml-10" v-if="d.permissoes.pode_gerenciar" type="text" size="mini"
                                   @click="bloquearTramite(t)">
                            {{ t.bloqueado ? 'desbloquear' : 'bloquear' }}
                        </el-button>
                    </span>
                </div>
                <div class="tramite-corpo" v-html="t.conteudo"></div>
                <div v-if="anexosDoTramite(t.id).length" class="u-mt-5">
                    <div v-for="a in anexosDoTramite(t.id)" :key="a.id" class="anexo">
                        <i class="el-icon-paperclip"></i>
                        <a href="#" @click.prevent="baixar(a)">{{ a.nome_original }}</a>
                    </div>
                </div>
            </div>

            <p v-if="!d.tramites.length" class="meta">Nenhuma movimentação ainda.</p>

            <!-- CI 58, 19 — responder com anexo -->
            <div v-if="d.permissoes.pode_tramitar" class="responder u-mt-20">
                <el-divider content-position="left">Responder</el-divider>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-select v-model="novo.tipo" style="width:100%">
                            <el-option label="Resposta"       value="resposta"></el-option>
                            <el-option label="Despacho"       value="despacho"
                                       :disabled="d.tipo && !d.tipo.permite_despacho"></el-option>
                            <el-option label="Encaminhamento" value="encaminhamento"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="18">
                        <!-- CI 46 -->
                        <el-select v-model="novo.representando_user_id" clearable placeholder="Em nome de (opcional)"
                                   style="width:100%">
                            <el-option v-for="p in participantesUsuarios" :key="p.ref_id"
                                       :label="p.nome" :value="p.ref_id"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <div class="u-mt-10">
                    <ckeditor v-model="novo.conteudo" :key="'ck-resp'"></ckeditor>
                </div>

                <el-upload class="area-arrastar u-mt-10" drag multiple action=""
                           :auto-upload="false" :file-list="anexosNovos"
                           :on-change="aoMudarAnexos" :on-remove="aoMudarAnexos">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Arraste anexos ou <em>clique para selecionar</em></div>
                </el-upload>

                <div class="u-text-right u-mt-10">
                    <el-button type="primary" @click="enviarTramite">ENVIAR MOVIMENTAÇÃO</el-button>
                </div>
            </div>

            <el-row class="u-mt-20">
                <el-col :xs="24">
                    <el-button type="default" icon="el-icon-back" @click="$router.push('/admin/tarefa')">
                        VOLTAR
                    </el-button>
                    <!-- CI 60 -->
                    <el-button v-if="d.permissoes.pode_concluir" type="success" icon="el-icon-circle-check"
                               @click="concluir">CONCLUIR TAREFA</el-button>
                    <!-- CI 42 -->
                    <el-button v-if="d.permissoes.pode_gerenciar" type="warning" icon="el-icon-lock"
                               @click="alternarBloqueio">
                        {{ d.tarefa.bloqueada ? 'LIBERAR TRÂMITES' : 'BLOQUEAR TRÂMITES' }}
                    </el-button>
                    <el-button class="u-ml-10" v-if="d.permissoes.pode_gerenciar && d.tarefa.situacao === 'enviada'"
                               type="danger" icon="el-icon-close" @click="cancelar">CANCELAR TAREFA</el-button>
                </el-col>
            </el-row>
        </div>

        <!-- edição de trâmite (CI 41) -->
        <el-dialog title="Editar movimentação" :visible.sync="dialogEdicao" width="60%">
            <ckeditor v-model="edicao.conteudo" :key="'ck-edit-'+(edicao.id||0)"></ckeditor>
            <span slot="footer">
                <el-button @click="dialogEdicao = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarEdicao">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- histórico de edições (CI 43) -->
        <el-dialog title="Histórico de edições" :visible.sync="dialogHistorico" width="60%">
            <div v-for="h in historico" :key="h.id" class="hist">
                <div class="meta">{{ h.editado_por }} · {{ h.editado_em | formatarData }}</div>
                <div class="hist-corpo" v-html="h.conteudo_anterior"></div>
            </div>
            <p v-if="!historico.length" class="meta">Sem edições registradas.</p>
        </el-dialog>

        <!-- incluir participante (CI 40) -->
        <el-dialog title="Incluir participante" :visible.sync="dialogParticipante" width="440px">
            <el-select v-model="novoParticipante" filterable remote :remote-method="buscarUsuarios"
                       :loading="buscando" placeholder="Digite o nome" style="width:100%">
                <el-option v-for="u in usuariosBusca" :key="u.id" :label="u.name" :value="u.id"></el-option>
            </el-select>
            <span slot="footer">
                <el-button @click="dialogParticipante = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="incluirParticipante">INCLUIR</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'
import ckeditor from '@/shared/ckeditor/ckeditor'

export default {
    props: ['paramId'],
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' },
        tamanho (b) {
            if (!b && b !== 0) return '—'
            if (b < 1024) return b + ' B'
            if (b < 1048576) return (b / 1024).toFixed(1) + ' KB'
            return (b / 1048576).toFixed(1) + ' MB'
        }
    },
    data: () => ({
        carregando: true,
        d: { tarefa: null, tipo: null, participantes: [], tramites: [], anexos: [], leituras: [], permissoes: {} },
        novo: { tipo: 'resposta', conteudo: '', representando_user_id: '' },
        anexosNovos: [],
        dialogEdicao: false,
        edicao: { id: null, conteudo: '' },
        dialogHistorico: false,
        historico: [],
        dialogParticipante: false,
        novoParticipante: '',
        usuariosBusca: [],
        buscando: false
    }),
    computed: {
        anexosDaTarefa () { return (this.d.anexos || []).filter(a => a.tarefa_id) },
        participantesUsuarios () { return (this.d.participantes || []).filter(p => p.tipo === 'usuario') },
        confirmeiLeitura () {
            const eu = this.$store.state.user
            if (!eu) return false
            const l = (this.d.leituras || []).find(x => Number(x.user_id) === Number(eu.id))
            return !!(l && l.confirmado_em)
        }
    },
    mounted () { this.carregar() },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const x = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (x && typeof x.erro === 'string') msg = x.erro
            else if (x && x.erro && x.erro.text) msg = x.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregar () {
            this.carregando = true
            this.$axios.get(`${this.base()}/api/tarefa/detalhe/${this.paramId}`, this.auth()).then(r => {
                this.d = r.data
                this.carregando = false
            }).catch(e => { this.carregando = false; this.erro(e) })
        },

        corSituacao (s) {
            if (s === 'enviada')   return 'primary'
            if (s === 'concluida') return 'success'
            if (s === 'cancelada') return 'danger'
            if (s === 'agendada')  return 'warning'
            return 'info'
        },

        corTramite (t) {
            if (t === 'despacho')       return 'warning'
            if (t === 'encaminhamento') return 'primary'
            if (t === 'conclusao')      return 'success'
            if (t === 'sistema')        return 'info'
            return ''
        },

        anexosDoTramite (id) { return (this.d.anexos || []).filter(a => Number(a.tramite_id) === Number(id)) },

        podeEditarTramite (t) {
            const eu = this.$store.state.user
            if (!eu || t.bloqueado || this.d.tarefa.bloqueada) return false
            if (t.tipo === 'conclusao' || t.tipo === 'sistema') return false
            return Number(t.user_id) === Number(eu.id) || this.d.permissoes.pode_gerenciar
        },

        aoMudarAnexos (file, fileList) { this.anexosNovos = fileList },

        enviarTramite () {
            if (!this.novo.conteudo || !this.novo.conteudo.replace(/<[^>]*>/g, '').trim()) {
                window.eventBus.$emit('alert', { msg: 'Escreva o conteúdo da movimentação.', type: 'warning' })
                return
            }

            const form = new FormData()
            form.append('tipo', this.novo.tipo)
            form.append('conteudo', this.novo.conteudo)
            if (this.novo.representando_user_id) {
                form.append('representando_user_id', this.novo.representando_user_id)
            }
            this.anexosNovos.forEach(f => { if (f.raw) form.append('arquivos[]', f.raw) })

            const cfg = Object.assign({}, this.auth())
            cfg.headers = Object.assign({}, cfg.headers, { 'Content-Type': 'multipart/form-data' })

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.base()}/api/tarefa-tramite/store/${this.paramId}`, form, cfg).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Movimentação registrada.', type: 'success' })
                this.novo = { tipo: 'resposta', conteudo: '', representando_user_id: '' }
                this.anexosNovos = []
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        abrirEdicao (t) {
            this.edicao = { id: t.id, conteudo: t.conteudo }
            this.dialogEdicao = true
        },

        salvarEdicao () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa-tramite/update/${this.edicao.id}`,
                { conteudo: this.edicao.conteudo }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Movimentação editada.', type: 'success' })
                this.dialogEdicao = false
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        verHistorico (t) {
            this.$axios.get(`${this.base()}/api/tarefa-tramite/historico/${t.id}`, this.auth()).then(r => {
                this.historico = r.data
                this.dialogHistorico = true
            }).catch(e => { this.erro(e) })
        },

        bloquearTramite (t) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa-tramite/bloquear/${t.id}`,
                { bloquear: !t.bloqueado }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        confirmarLeitura () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa/confirmar-leitura/${this.paramId}`, {}, this.auth())
                .then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Leitura confirmada.', type: 'success' })
                    this.carregar()
                }).catch(e => { this.erro(e) })
        },

        concluir () {
            this.$msgbox.confirm('Concluir esta tarefa?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/tarefa/concluir/${this.paramId}`, {}, this.auth())
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Tarefa concluída.', type: 'success' })
                        this.carregar()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        cancelar () {
            this.$msgbox.confirm('Cancelar esta tarefa?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/tarefa/cancelar/${this.paramId}`, {}, this.auth())
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Tarefa cancelada.', type: 'success' })
                        this.carregar()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        alternarBloqueio () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa/bloquear/${this.paramId}`,
                { bloquear: !this.d.tarefa.bloqueada }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        buscarUsuarios (termo) {
            if (!termo || termo.length < 2) return

            const grupo = (this.d.participantes || []).find(p => p.tipo === 'grupo')
            if (!grupo) {
                window.eventBus.$emit('alert', {
                    msg: 'Esta tarefa não tem grupo de trabalho para localizar pessoas.', type: 'warning'
                })
                return
            }

            this.buscando = true
            this.$axios.post(`${this.base()}/api/grupo-trabalho/usuarios-disponiveis/${grupo.ref_id}`,
                { termo: termo }, this.auth()).then(r => {
                this.usuariosBusca = r.data
                this.buscando = false
            }).catch(e => { this.buscando = false; this.erro(e) })
        },

        incluirParticipante () {
            if (!this.novoParticipante) return

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa/participante-incluir/${this.paramId}`,
                { participantes: [{ tipo: 'usuario', ref_id: this.novoParticipante }] }, this.auth()
            ).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Participante incluído.', type: 'success' })
                this.dialogParticipante = false
                this.novoParticipante = ''
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        baixar (a) {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'

            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.base()}/api/tarefa/baixar/${a.id}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                const url = window.URL.createObjectURL(new Blob([r.data], { type: a.mime }))
                const el = document.createElement('a')
                el.href = url
                el.download = a.nome_original
                document.body.appendChild(el)
                el.click()
                document.body.removeChild(el)
                window.URL.revokeObjectURL(url)
            }).catch(e => { this.erro(e) })
        },

        // CI 61 — relatório do histórico
        relatorio () {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'

            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.base()}/api/tarefa/relatorio/${this.paramId}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                window.open(url, '_blank')
            }).catch(e => { this.erro(e) })
        }
    },
    components: { ckeditor }
}
</script>
<style scoped>
.titulo   { margin: 0 0 4px; font-size: 18px; }
.meta     { color: #909399; font-size: 12px; }
.ident    { font-family: monospace; }
.rotulo   { display: block; font-size: 12px; color: #606266; text-transform: uppercase; margin-bottom: 4px; }
.corpo    { border: 1px solid #EBEEF5; border-radius: 4px; padding: 12px; background: #fff; min-height: 80px; }
.painel   { border: 1px solid #EBEEF5; border-radius: 4px; padding: 12px; background: #FAFAFA; }
.participante, .leitura { font-size: 13px; padding: 2px 0; }
.confirmou { color: #67C23A; }
.anexo    { font-size: 13px; padding: 2px 0; }
.tramite  { border-left: 3px solid #DCDFE6; padding: 8px 12px; margin-bottom: 10px; background: #fff; }
.tramite-cab { font-size: 12px; color: #606266; margin-bottom: 5px; }
.tramite-corpo { font-size: 14px; }
.acoes-tramite { float: right; }
.hist     { border-bottom: 1px dashed #EBEEF5; padding: 8px 0; }
.hist-corpo { background: #FAFAFA; padding: 8px; border-radius: 3px; }
.responder { border-top: 1px solid #EBEEF5; padding-top: 10px; }
.area-arrastar >>> .el-upload, .area-arrastar >>> .el-upload-dragger { width: 100%; }
.area-arrastar >>> .el-upload-dragger { height: 90px; }
.u-ml-5 { margin-left: 5px; }
</style>
